export const externalCompanyIdentifier = {
  Vuso: 1001,
  Tas: 1003,
  Express: 1006,
  Knajza: 1007,
  Guardian: 1008,
  Utsk: 1009,
  InterPolis: 1011,
  Oranta: 1012,
  Euroins: 1014,
  Eia: 1015,
  Usg: 1017,
  PZU: 1023,
  Ingo: 1025,
  Arsenal: 1026,
  ARX: 1027,
};

export const legacyExternalCompanyIdentifier = {
  Ingo: 1010,
};
